import { DOMAIN, urlParam } from "../config";

//How long a fresh connection to each candidate network takes from the
//visitor's own phone: a 2-byte file on Amazon CloudFront against a Cloudflare
//host the visitor has not opened yet. The landers' Indian mobile visitors
//(Jio, Airtel, Vi) reach Cloudflare in Marseille, Singapore or Boston; this
//shows whether CloudFront serves them from India and how much faster. Every
//visit, three seconds after the page has loaded, one network after the
//other in random order, so the page itself never waits for it.
const SHARE = 1;
const DELAY_MS = 3000;
const TIMEOUT_MS = 10000;
const PROBES = [
	{ network: "cloudfront", url: "https://dq38yk0a7ikk8.cloudfront.net/probe.txt" },
	{ network: "cloudflare", url: "https://nutracod.com/cdn-cgi/trace" },
];

function edgeOf(network, response, text) {
	if (network === "cloudfront") {
		return response.headers.get("x-amz-cf-pop") || "";
	}
	const match = /^colo=([A-Z]+)$/m.exec(text);
	return match ? match[1] : "";
}

//The browser's resource timing gives the whole fetch, connection included;
//the parts (DNS, connect, TLS, wait) only where the host allows it
//(Timing-Allow-Origin, CloudFront here). Without an entry - a full timing
//buffer on an image-heavy page - the fetch's own clock stands in.
function measure(probe) {
	const url = probe.url + "?r=" + Math.random().toString(36).slice(2);
	const controller = new AbortController();
	const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
	const started = performance.now();

	return fetch(url, { cache: "no-store", credentials: "omit", signal: controller.signal })
		.then((response) => response.text().then((text) => ({ response, text })))
		.then(({ response, text }) => {
			clearTimeout(timer);
			const ms = (value) => Math.max(0, Math.round(value));
			const result = { duration: ms(performance.now() - started), edge: edgeOf(probe.network, response, text) };
			const entry = performance.getEntriesByName(url).pop();
			if (entry) {
				result.duration = ms(entry.duration);
				if (entry.requestStart > 0) {
					result.dns = ms(entry.domainLookupEnd - entry.domainLookupStart);
					result.connect = ms(entry.connectEnd - entry.connectStart);
					result.wait = ms(entry.responseStart - entry.requestStart);
					if (entry.secureConnectionStart > 0) {
						result.tls = ms(entry.connectEnd - entry.secureConnectionStart);
					}
				}
				if (entry.nextHopProtocol) {
					result.protocol = entry.nextHopProtocol;
				}
			}
			return result;
		})
		.catch(() => {
			clearTimeout(timer);
			return null;
		});
}

function runProbes(transactionId) {
	const order = PROBES.slice().sort(() => Math.random() - 0.5);
	const results = {};

	order
		.reduce(
			(chain, probe) =>
				chain.then(() =>
					measure(probe).then((result) => {
						if (result) {
							results[probe.network] = result;
						}
					}),
				),
			Promise.resolve(),
		)
		.then(() => {
			const body = new URLSearchParams({ transaction_id: transactionId, first: order[0].network });
			Object.keys(results).forEach((network) => {
				Object.keys(results[network]).forEach((key) => {
					body.set(network + "[" + key + "]", results[network][key]);
				});
			});
			if (Object.keys(results).length) {
				fetch(DOMAIN + "/funnels-sdk/network-probes", { method: "POST", body, keepalive: true }).catch(() => {});
			}
		});
}

export function networkProbe() {
	const transactionId = urlParam("transaction_id");
	if (!transactionId || Math.random() >= SHARE || !window.fetch || !window.AbortController) {
		return;
	}

	const start = () => setTimeout(() => runProbes(transactionId), DELAY_MS);
	if (document.readyState === "complete") {
		start();
	} else {
		window.addEventListener("load", start, { once: true });
	}
}
